<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents dashboard">
					<div class="box-dashboard">
						<dashboard-member-component></dashboard-member-component>
						<div class="box-chart">
							<dashboard-member-inout-component></dashboard-member-inout-component>
						</div>
					</div>
					<div class="box-dashboard">
						<dashboard-licence-component></dashboard-licence-component>
						<dashboard-product-component></dashboard-product-component>
						<dashboard-licence-product-component></dashboard-licence-product-component>
					</div>
					<div class="box-dashboard">
						<dashboard-licence-genuine-component></dashboard-licence-genuine-component>
						<dashboard-product-genuine-component></dashboard-product-genuine-component>
						<dashboard-licence-product-genuine-component></dashboard-licence-product-genuine-component>
					</div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardMemberComponent from "@/components/dashboard/DashboardMemberComponent";
import DashboardMemberInoutComponent from "@/components/dashboard/DashboardMemberInoutComponent";
import DashboardLicenceComponent from "@/components/dashboard/DashboardLicenceComponent";
import DashboardProductComponent from "@/components/dashboard/DashboardProductComponent";
import DashboardLicenceProductComponent from "@/components/dashboard/DashboardLicenceProductComponent";
import DashboardLicenceGenuineComponent from "@/components/dashboard/DashboardLicenceGenuineComponent";
import DashboardProductGenuineComponent from "@/components/dashboard/DashboardProductGenuineComponent";
import DashboardLicenceProductGenuineComponent from "@/components/dashboard/DashboardLicenceProductGenuineComponent";
export default {
    name: "Dashboard",
    components: {DashboardMemberComponent,DashboardMemberInoutComponent,DashboardLicenceComponent,DashboardProductComponent,DashboardLicenceProductComponent,DashboardLicenceGenuineComponent,DashboardProductGenuineComponent,DashboardLicenceProductGenuineComponent },
    mixins: [],
    data() {
        return {};
    },
    computed: {},
    mounted() {},

    methods: {},
};
</script>
<style>
</style>
